export const homeObjOne = {
	id: "about",
	lightBg: false,
	lightText: true,
	lightTextDesc: true,
	topLine: "About Adazeus Token",
	headline: "Create a Safehaven For Token Traders",
	description:
		"Our main goal is to provide people a safe and trustworthy place where they can invest their money. Adazeus holders can earn ADA rewards by holding a certain amount of the token. As a community developed token, we focus on the needs of our community members.",
	imgStart: false,
	img: require("../../images/about.svg").default,
	alt: "Car",
	dark: true,
	primary: true,
	darkText: false,
};

export const homeObjTwo = {
	id: "tokenomics",
	lightBg: true,
	lightText: false,
	lightTextDesc: false,
	topLine: "Tokenomics",
	headline: "Best Tokenomics deal for Holder",
	buttonLabel: "Learn More",
	imgStart: true,
	img: require("../../images/tokenomics.svg").default,
	alt: "PiggyBank",
	dark: false,
	primary: false,
	darkText: true,
	d1: "2% Max Transaction",
	d2: "10.000.000.000 Total Supply",
	d3: "3% Max Wallet",
	d4: "7% ADA Reward",
	d5: "4% Liquidity Provider",
	d6: "6% Marketing",
	d7: "60 Seconds Cooldown Buys at Launch",
};
